import React from 'react';
import { styled } from '@mui/material/styles';

type TProps = {
  value: string;
  onChange: (value: React.SetStateAction<string>) => void;
  placeholder: string;
  maxLength: number;
};

export const InputArea: React.FC<TProps> = ({
  value,
  onChange,
  placeholder,
  maxLength
}) => {
  return (
    <InputContainer>
      <TextInput
        value={value}
        placeholder={placeholder}
        type='text'
        maxLength={maxLength} // props で渡された maxLength を適用
        onChange={text => {
          onChange(text.target.value);
        }}
      />
    </InputContainer>
  );
};

const InputContainer = styled('div')({
  marginLeft: 10,
  marginRight: 10,
  paddingRight: 10,
  width: '100%'
});

const TextInput = styled('input')({
  height: 40,
  width: '100%',
  borderColor: '#c1c1c1',
  borderWidth: 1
});
